import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import { FiltersDto } from "@models/FiltersDto";

interface RowHeightOption {
  id: string;
  value: string;
  label: string;
  initialSelected: boolean;
}

interface FiltersState {
  selectedDepartments: FiltersDto[];
  selectedSections: FiltersDto[];
  season: FiltersDto | null;
  rowHeight: RowHeightOption | null;
}

// Helper function to validate the tab value

const initialState: FiltersState = {
  selectedDepartments: [],
  selectedSections: [],
  season: null,
  rowHeight: {
    label: "Standard",
    value: "32",
    id: "standard",
    initialSelected: true,
  },
};

export const filterSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    changeSeasonFilter: (state, action) => {
      state.season = action.payload;
    },
    addSelectedDepartment: (state, action: PayloadAction<FiltersDto>) => {
      const exists = state.selectedDepartments.some(
        (d) => d.id === action.payload.id,
      );
      if (!exists) {
        state.selectedDepartments.push(action.payload);
      }
    },
    removeSelectedDepartment: (state, action: PayloadAction<number>) => {
      state.selectedDepartments = state.selectedDepartments.filter(
        (d) => d.id !== action.payload,
      );
    },
    setSelectedDepartments: (state, action: PayloadAction<FiltersDto[]>) => {
      state.selectedDepartments = action.payload;
    },
    setSelectedSections: (state, action: PayloadAction<FiltersDto[]>) => {
      state.selectedSections = action.payload;
    },
    changeRowHeight: (state, action: PayloadAction<RowHeightOption>) => {
      state.rowHeight = action.payload;
    },
    mergeDepartmentData: (
      state,
      action: PayloadAction<
        Array<{
          departmentId: number;
          isScaEditEnabled: boolean;
          allowedInternalAttributes?: Array<{ id: number; value: string }>;
          excludedTaxonomyFieldsForDepartment?: string[];
        }>
      >,
    ) => {
      const infoMap = new Map(action.payload.map((d) => [d.departmentId, d]));
      for (const dept of state.selectedDepartments) {
        const info = infoMap.get(Number(dept.id));
        if (info && dept.data) {
          dept.data.isScaEditEnabled = info.isScaEditEnabled;
          if (info.allowedInternalAttributes) {
            dept.data.allowedInternalAttributes =
              info.allowedInternalAttributes;
          }
          if (info.excludedTaxonomyFieldsForDepartment) {
            dept.data.excludedTaxonomyFieldsForDepartment =
              info.excludedTaxonomyFieldsForDepartment;
          }
        }
      }
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  changeSeasonFilter,
  addSelectedDepartment,
  removeSelectedDepartment,
  setSelectedDepartments,
  setSelectedSections,
  changeRowHeight,
  mergeDepartmentData,
} = filterSlice.actions;

export default filterSlice.reducer;
